import React from 'react';
import { Row } from 'antd';
import LoginContent from './LoginContent';

class App extends React.Component {

  render() {
    const {
      isEclogin,
    } = this.props;
    return (
      <Row className='init-login' type="flex" justify="space-around" align="middle">
        <LoginContent isEclogin={isEclogin}/>
        <div className='copy-right'>
  				<p><a target="_blank" href="http://www.weaver.com.cn">版权所有：上海泛微网络科技股份有限公司</a></p>
	  			<p>Copyright © 2001-2021 Weaver Network All Rights Reserved.<a target="_blank" href="https://beian.miit.gov.cn">沪ICP备05040488号-11</a></p>
				</div>
      </Row>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/init/Login.js